/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AccountResourceApi} from "./api/account-resource.api";
import {ApiConfig} from "./api/config.api";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class AuthServerProvider {

  constructor(private httpClient:HttpClient,
              private accountResourceApi:AccountResourceApi) {
  }

  login(credentials):Observable<any> {
    return this.accountResourceApi.check(credentials);
  }

  logout():Observable<any> {
    return this.httpClient.post(ApiConfig.baseURL + 'api/logout', '', {headers: ApiConfig.requestOptionsHeader});
  }
}
